import { ROUTINES_FEATURE_FLAG } from 'featureFlags/config';
import { useFeatureFlag, useParticipantsFeatureFlag } from 'featureFlags/hooks';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

export const useRoutinesFFEnabled = () => {
  const userMode = useUserMode();
  const participantRoutinesEnabled = useParticipantsFeatureFlag(
    ROUTINES_FEATURE_FLAG
  );
  const myRoutinesEnabled = useFeatureFlag(ROUTINES_FEATURE_FLAG);

  if (userMode === USER_MODES.dashboard) {
    return myRoutinesEnabled;
  }

  return participantRoutinesEnabled;
};
